import { useWebStoreContext } from "contexts";
import { useMemo } from "react";

const useLiveopsConfigs = (ids: string[]): Record<string, string> => {
	const { store } = useWebStoreContext();
	const config = store?.globalConfig ?? [];

	const configKey = useMemo(() => JSON.stringify(config), [config]);

	const result = useMemo(() => {
		const configMap: Record<string, string> = {};
		ids.forEach((id) => {
			configMap[id] = config.find((cfg) => cfg.id === id)?.value ?? "";
		});
		return configMap;
	}, [configKey, ids]);

	return result;
};

export default useLiveopsConfigs;
